import { __extends } from "tslib";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from "react";
import '../../Css/electron-toolbar.css';
import ElectronUtils from './../../Core/Electron';
var ElectronToolbar = /** @class */ (function (_super) {
    __extends(ElectronToolbar, _super);
    /**
     * Class constructor
     * @param {any} props Component props
     * @returns {void}
     */
    function ElectronToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.Init();
        return _this;
    }
    /**Minimize window */
    ElectronToolbar.prototype.Init = function () {
        this.state = {
            Maximized: ElectronUtils.Init()
        };
    };
    /**Navigate back*/
    ElectronToolbar.prototype.Back = function () {
        ElectronUtils.Back();
    };
    /**Navigate forward */
    ElectronToolbar.prototype.Forward = function () {
        ElectronUtils.Forward();
    };
    /**Refresh */
    ElectronToolbar.prototype.Refresh = function () {
        ElectronUtils.Refresh();
    };
    /**Minimize window */
    ElectronToolbar.prototype.Minimize = function () {
        ElectronUtils.Minimize();
    };
    /**Maximize window */
    ElectronToolbar.prototype.Maximize = function () {
        this.setState({
            Maximized: ElectronUtils.Maximize()
        });
    };
    /**Close window */
    ElectronToolbar.prototype.Quit = function () {
        ElectronUtils.Quit();
    };
    /**
     * Render component
     * @returns {JSX.Element} Component layout
     */
    ElectronToolbar.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "electron-toolbar" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-5 buttons navigation" },
                    React.createElement("div", { className: "button back", onClick: function () { _this.Back(); } },
                        React.createElement(FontAwesomeIcon, { icon: ['far', 'chevron-left'] })),
                    React.createElement("div", { className: "button forward", onClick: function () { _this.Forward(); } },
                        React.createElement(FontAwesomeIcon, { icon: ['far', 'chevron-right'] })),
                    React.createElement("div", { className: "button refresh", onClick: function () { _this.Refresh(); } },
                        React.createElement(FontAwesomeIcon, { icon: ['far', 'sync-alt'] }))),
                React.createElement("div", { className: "col-2 app-title" }, "B2C-Portal"),
                React.createElement("div", { className: "col-5 buttons window" },
                    React.createElement("div", { className: "button minimize", onClick: function () { _this.Minimize(); } },
                        React.createElement(FontAwesomeIcon, { icon: ['far', 'window-minimize'] })),
                    this.state.Maximized ?
                        React.createElement("div", { className: "button restore", onClick: function () { _this.Maximize(); } },
                            React.createElement(FontAwesomeIcon, { icon: ['far', 'window-restore'] }))
                        :
                            React.createElement("div", { className: "button maximize", onClick: function () { _this.Maximize(); } },
                                React.createElement(FontAwesomeIcon, { icon: ['far', 'window-maximize'] })),
                    React.createElement("div", { className: "button quit", onClick: function () { _this.Quit(); } },
                        React.createElement(FontAwesomeIcon, { icon: ['far', 'times'] }))))));
    };
    return ElectronToolbar;
}(React.PureComponent));
export { ElectronToolbar };
//# sourceMappingURL=ElectronToolbar.js.map